var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#FFEBA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11C16.328 11 17 10.328 17 9.5C17 8.672 16.328 8 15.5 8C14.672 8 14 8.672 14 9.5C14 10.328 14.672 11 15.5 11Z",
    fill: "#1A1B43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50001 11C9.32801 11 10 10.328 10 9.5C10 8.672 9.32801 8 8.50001 8C7.67201 8 7.00001 8.672 7.00001 9.5C7.00001 10.328 7.67201 11 8.50001 11Z",
    fill: "#1A1B43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.991H9.00001C8.44801 15.991 8.00001 15.543 8.00001 14.991C8.00001 14.439 8.44801 13.991 9.00001 13.991H15C15.552 13.991 16 14.439 16 14.991C16 15.543 15.552 15.991 15 15.991Z",
    fill: "#1A1B43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.47001 2 2.00001 6.48 2.00001 12C2.00001 17.52 6.47001 22 11.99 22C17.51 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58001 20 4.00001 16.42 4.00001 12C4.00001 7.58 7.58001 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "#1A1B43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNeutral);
export default __webpack_public_path__ + "static/media/icon-neutral.f47092467306ee47e8811015453de0bb.svg";
export { ForwardRef as ReactComponent };